/**
 * @file PaddleHub 首页教学卡片
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';
import {RightOutlined} from '@ant-design/icons';
import {ITeaching} from '../../types';
import A from '../../../../components/a/A';

const TextCards: React.FC<ITeaching> = props => {
    const {list, linkMore} = props;

    return (
        <div className="paddle-text-card-wrap">
            <div className="paddle-text-card-group clear-both">
                {list.map(item => (
                    <div key={`${item.title}${item.content}`} className="paddle-text-card-gird">
                        <A
                            key={item.title}
                            className="paddle-text-card"
                            href={item.links?.href}
                        >
                            <div className="paddle-text-card-head">
                                <div className="paddle-text-card-title">
                                    {item.title}
                                </div>
                            </div>
                            <div className="paddle-text-card-body">
                                <div className="paddle-text-card-context">
                                    {item.content}
                                </div>
                                <div className="paddle-text-card-tags">
                                <span>
                                    {item.links?.label}
                                </span>
                                </div>
                            </div>
                        </A>
                    </div>
                ))}
            </div>
            {!!(linkMore && linkMore.label)
            && (
                <div className="paddle-text-card-link">
                    <a href={linkMore.href}>
                        {linkMore.label} <RightOutlined className="paddle-text-card-right-icon" />
                    </a>
                </div>
            )}
        </div>
    );
};

export default TextCards;
